import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Book } from '../../../shared/models/book';

@Component({
  selector: 'app-page-from-book-enrichment',
  templateUrl: './page-from-book-enrichment.component.html',
  styleUrls: ['./page-from-book-enrichment.component.css']
})
export class PageFromBookEnrichmentComponent implements OnInit {

  @Input() pageFromBookObj: any;
  @Output() globalServicesCallBack: EventEmitter<any> = new EventEmitter<any>();

  public showAllowedType: boolean = true;
  public showNotAllowedType: boolean = false;
  public showAllType: boolean = false;
  public showBookThumbs: boolean = false;
  public currentSelectedBook: Book;
  public currentSelectedBookThumbs = [];
  public selectedThumbs = [];
  public showPreview: boolean = false
  public imagePreviewUrl = "";
  public state: number = 0;
  // for temp purpose
  public availableBooks = [{
    "id": "001",
    "author": " التغعفغععليم",
    "language": "Arabic",
    "pageCount": 248,
    "type": "pdf",
    "title": " النشاط",
    "ISBIN": "3088",
    "description": "الصف الاو",
    "price": 1.00,
    "zipUrl": "http://school.nooor.com/Semalibrary/Sboook/Pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/0f9d5153-43c4-44ff-b600-39f52bf09981.zip",
    "thumbnailUrl": "http://hyd.semanooor.com/NooorM/Pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/cover.png",
    "previewUrl": "http://hyd.semanooor.com/NooorM/Pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Pdf.pdf",
    "tags": "Test",
    "_id": "cjfjazaa5pix40b39mlsfp5oi_cjfozkx7wa0wf0b62g3s9q9vm.3088.book"
  }, {
    "id": "001",
    "title": "سيب بسيب",
    "language": "Arabic",
    "pageCount": 164,
    "author": "سيب سيبسب",
    "type": "pdf",
    "ISBIN": "25",
    "description": "الصف الاو",
    "price": 1.00,
    "zipUrl": "http://school.nooor.com/Semalibrary/Sboook/Pdf/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8.zip",
    "thumbnailUrl": "http://hyd.semanooor.com/NooorM/Pdf/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8/cover.png",
    "previewUrl": "http://hyd.semanooor.com/NooorM/Pdf/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8/Pdf.pdf",
    "tags": "Test",
    "_id": "cjfjazaa5pix40b39mlsfp5oi_cjfozkx7wa0wf0b62g3s9q9vm.2141.book"
  }];

  public availableBooksThumbs = {};

  //public bookObj: Book;
  //

  constructor() { }

  ngOnInit() {
    var self = this;
    // for temp purpose
    let bookThumbs = [];
    for (var i = 1; i <= 116; i++) {
      var url = "http://hyd.semanoor.com/NooorM/pdfImages/" + i + ".png";
      var obj = {
        isThumbActive: false,
        url: url
      }
      bookThumbs.push(obj);
    }
    //Pushing the all the available books thumbs in to availableBooksThumbs object
    for (let k = 0; k <= this.availableBooks.length; k++) {
      if (self.availableBooks[k]) {
        let bookId = self.availableBooks[k]._id
        self.availableBooksThumbs[bookId] = JSON.parse(JSON.stringify(bookThumbs));
      }
    }
  }

  hidePageFromBookDialog(evt) {
    if (evt) {
      evt.stopPropagation();
    }
    else {
      this.pageFromBookObj.showPopup = false;
    }
  }

  tabChanged(evt) {
    this.state = 0;

    this.showAllowedType = evt.index == 0;
    this.showNotAllowedType = evt.index == 1;
    this.showAllType = evt.index == 2;

    this.showBookThumbs = false;
    this.showPreview = false;
    this.currentSelectedBookThumbs = [];
    // this.selectedThumbs = [];
  }

  showThumbs(book) {
    this.state = 1;
    this.showBookThumbs = true;
    this.showAllowedType = false;
    this.showNotAllowedType = false;
    this.showAllType = false;
    this.currentSelectedBook = book;
    this.currentSelectedBookThumbs = this.availableBooksThumbs[book._id];
  }

  onThumbClick(thumb) {

    thumb.isThumbActive = !thumb.isThumbActive;

    if (thumb.isThumbActive) {
      this.selectedThumbs.push(thumb);
    }
    else {
      var indOfThumb = this.selectedThumbs.findIndex(x => x.url == thumb.url);
      if (indOfThumb != -1) {
        this.selectedThumbs.splice(indOfThumb, 1);
      }
    }

  }

  onPreviewClick(event, thumb) {
    event.stopPropagation();
    this.state = 2;
    this.imagePreviewUrl = thumb.url;
    this.showBookThumbs = false;
    this.showPreview = true;
  }

  backToThumbs() {
    // this.showBookThumbs = true;
    // this.showPreview = false;
  }

  back() {
    if (this.state == 2) {
      this.state = 1;
      this.showBookThumbs = true;
      this.showPreview = false;
    }
    else if (this.state == 1) {
      this.state = 0;
      this.showBookThumbs = false;
      this.showAllowedType = true;
    }
  }

  addAsTab() {

    var obj = {
      "type": "pageFromBook",
      "selectedThumbs": this.selectedThumbs
    }
    if (this.selectedThumbs.length>0) {
      this.globalServicesCallBack.emit(obj);
      this.hidePageFromBookDialog(undefined);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/page-from-book-enrichment/page-from-book-enrichment.component.ts